import { useTranslation } from 'react-i18next'
import CopyButton from '../components/CopyButton';
import NextSectionCard from '../components/NextSectionCard';
import { timeSince } from '../utils/timeSince';
import PreviousSectionCard from '../components/PreviousSectionCard';
import caseIcon from "../assets/icons/case.svg";

const PDFSign = () => {
    const { t, i18n } = useTranslation();
    const lastUpdated = "2025-12-05";
    const lang = i18n.language;

    const buildCopyText = (t) => {
        return "";
    }
    return (
        <div className="text-black dark:text-white">
            <div
                className="
          desktop:px-4
          py-3
          max-w-3xl
        "
            >
                <div className="relative flex items-center justify-between gap-3">
                    <div className="flex items-center gap-1">
                        <div>
                            <img src={caseIcon} alt="case" className="w-6 h-6" />
                        </div>
                        <div>
                            <p className="text-[16px] tabletpro:text-[12px] mini_mobile:text-[14px] text-[#0087FE] font-normal">
                                {t("sidebar.cases.title").toUpperCase()}
                            </p>
                        </div>
                    </div>

                    <CopyButton text={buildCopyText(t)} />
                </div>

                <div className="mt-2 relative">
                    <section className='flex gap-4'>
                        <p className='text-[#020617] dark:text-[#F8FAFC] text-[40px] tabletpro:text-[22px] mini_mobile:text-[24px] mobile:text-[30px] font-semibold'>{t("sidebar.cases.pdfSign")}</p>
                    </section>

                    <section className='flex gap-4 mt-1'>
                        <p className='text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]'>{t("common.comingsoon")}</p>
                    </section>

                    <section className='flex gap-4 mt-4 flex-col desktop:flex-row'>
                        <PreviousSectionCard
                            label={t("sidebar.cases.foxit")}
                            to="/cases/foxit"
                        />
                        <NextSectionCard
                            label={t("sidebar.cases.acrobatReader")}
                            to="/cases/acrobat-reader"
                        />
                    </section>

                    {/* Last updated */}
                    <section className='flex gap-4 mt-4'>
                        <span className="text-[14px] text-[#64748B]">
                            {t("welcome.lastUpdatedBase")} {timeSince(lastUpdated, lang)}
                        </span>
                    </section>
                </div>

            </div>
        </div>

    )
}

export default PDFSign
